import { createSelector } from 'reselect';
import pageSelector from 'selectors/pageSelector';
import playingContentSelector from 'selectors/playingContentSelector';
import playerSelector from 'selectors/playerSelector';
import selectedContentSelector from 'selectors/selectedContentSelector';
import { userAuthSelector, ipSelector, adobePassSelector } from 'selectors/authenticationSelectors';
import { contentHasAuthType, shallowCheckAuthentication } from 'lib/auth';

/**
 * This selector only returns content if all the conditions needed for playback are met
 */
export default createSelector(
    pageSelector,
    playerSelector,
    playingContentSelector,
    selectedContentSelector,
    userAuthSelector,
    ipSelector,
    adobePassSelector,
    (page, player, playingContent, selectedContent, userAuth, ipInfo, adobePassInfo) => {
        if (
            page.scored &&
            player.ready === true &&
            Object.keys(selectedContent).length > 0 &&
            selectedContent.reEmbed !== false &&
            player.autoEmbedTimerComplete === true &&
            selectedContent.id !== playingContent.id
        ) {
            if (shallowCheckAuthentication(selectedContent, userAuth, false) === true) {
                if (!selectedContent.authTypes || selectedContent.authTypes.length === 0 ||
                    selectedContent.sourceId === 'SHORTSTOPLIVE') {
                    return { ...selectedContent };
                } else if (contentHasAuthType(selectedContent, 'isp') && userAuth.indexOf('isp') !== -1) {
                    return { ...selectedContent, ipInfo };
                } else if (contentHasAuthType(selectedContent, 'mvpd') && adobePassInfo) {
                    return { ...selectedContent, adobePassInfo };
                }
            }
        }
        return {};
    }
);



// WEBPACK FOOTER //
// ./app/selectors/onDeckContentSelector.js